/* eslint-disable react/prop-types */
import React from 'react';

function InsertContentRenderer({ insertContent }) {
  if (typeof (insertContent) == 'object') {
    return insertContent;
  } if (typeof (insertContent) == 'string') {
    return (
      <div dangerouslySetInnerHTML={{ __html: insertContent }} />
    );
  }
  return null;
}

export default InsertContentRenderer;
